import React from 'react';
import { List, ListItem, ListType, Icon, IconNames, CUIText } from '@dotcom/crown-ui';
import { NoPhotosUploadedProps } from '../photo-drawer-types';
import styles from '../photo-drawer.module.scss';

export const NoPhotosUploaded = ({
  labels,
  onDrawerImageUpload,
  inputFileRef,
}: NoPhotosUploadedProps): React.ReactElement => {
  const handleUploadDrawerImages = () => {
    onDrawerImageUpload && onDrawerImageUpload();
  };

  return (
    <button
      data-testid={`photo-upload-button`}
      className={styles['no-photos-uploaded-container']}
      onClick={() => {
        inputFileRef.current?.click();
        handleUploadDrawerImages();
      }}
    >
      <Icon className={styles['photo-lot-icon']} name={IconNames.PhotoslotBold} size={'40'} />
      <div className={styles['no-photos-uploaded-text']}>
        <CUIText
          className={styles['no-photos-uploaded-title']}
          as="span"
          variant="body"
          weight="bold"
          color="textPrimary"
        >
          {labels.title}
        </CUIText>
        <List listStyle={ListType.Bullets} className={styles['no-photos-uploaded-list']}>
          {labels.steps.map((step) => (
            <ListItem className={styles['no-photos-uploaded-step']} key={step}>
              <CUIText as="span" color="textSecondary">
                {step}
              </CUIText>
            </ListItem>
          ))}
        </List>
      </div>
    </button>
  );
};
